import { memo } from "react";
import type { EarlyStageVerificationStatus } from "../../api/earlyStageMembershipApi";
import { needsEarlyStagePricePlanSelection } from "./registrationResume";

interface EarlyStageRegistrationNoticeProps {
  status: EarlyStageVerificationStatus | null;
  /** Current registration step index (Early Stage path). */
  step: number;
  /** Direct £10/month Early Stage — no admin approval messaging. */
  directStandardPath?: boolean;
}

function EarlyStageRegistrationNoticeInner({
  status,
  step,
  directStandardPath = false,
}: EarlyStageRegistrationNoticeProps) {
  if (!status || status.status === "NotApplicable") return null;

  if (status.status === "Pending" || status.status === "UnderReview") {
    return (
      <div className="alert alert-warning mb-3" role="status">
        <strong>Your ID verification is pending.</strong> An admin will review
        your documents. You can continue registration once approved — we will
        bring you back to payment when you sign in again.
      </div>
    );
  }

  if (status.status === "Rejected") {
    return (
      <div className="alert alert-danger mb-3" role="status">
        <strong>Your Young Professional application was rejected.</strong> Your membership is
        £10/month. If you have questions, email enquiries@smbf.global or use
        Contact Us on this page.
      </div>
    );
  }

  if (
    status.status === "Approved" &&
    needsEarlyStagePricePlanSelection(status) &&
    step === 2
  ) {
    return (
      <div className="alert alert-success mb-3" role="status">
        <strong>You are approved.</strong> Choose £2/month or £10/month, then
        continue to terms and payment.
      </div>
    );
  }

  if (status.status === "Approved" && status.canPay && step === 5) {
    if (directStandardPath) return null;

    return (
      <div className="alert alert-success mb-3" role="status">
        <strong>You are approved.</strong> Complete your payment below.
      </div>
    );
  }

  return null;
}

export default memo(EarlyStageRegistrationNoticeInner);
